import { useState } from "react";
import Button from "../../../components/atoms/buttons/Button";

interface IProps {
  filterOptions: Array<string>;
  className: string;
  activeFilterIndex?: number;
  onFilterSelect: (string: string) => void;
}
function FilterButtons({ filterOptions, activeFilterIndex = 0, className, onFilterSelect }: IProps) {
  const [activeFilter, setActiveFilter] = useState<number>(activeFilterIndex);
  const handleFilterClick = (filter: string, index: number) => {
    if (activeFilter === index) return;
    setActiveFilter(index);
    onFilterSelect(filter);
  };
  return (
    <div className={`box-border flex w-full flex-wrap gap-1 md:gap-2 ${className}`}>
      {filterOptions.map((filter, index) => (
        <Button
          additionalClasses={`pt-2 pb-2 pl-5 pr-5 h-10 font-sora font-500 md:text-xxs lg:text-xs xl:text-xs border-2 ${
            index === activeFilter ? "bg-secondary border-secondary text-primary" : "bg-primary text-white"
          }`}
          key={filter}
          text={filter[0] + filter.slice(1).toLowerCase()}
          onClick={() => handleFilterClick(filter, index)}
        />
      ))}
    </div>
  );
}

export default FilterButtons;
FilterButtons.defaultProps = {
  activeFilterIndex: 0,
};
